import type { ResolveNodeIdsWithConfigReferences } from "@skilitics/nautilus-core-designer-data";

import type { GetDesignerNodeById } from "./getDesignerNodeById.ts";

export const resolveNodesWithVariableReferencesCreate =
  (resolveNodeIdsWithVariableReferences: ResolveNodeIdsWithConfigReferences, getNodeById: GetDesignerNodeById) =>
  (toVariableOnNodeId: number) =>
    resolveNodeIdsWithVariableReferences(toVariableOnNodeId).map(getNodeById);

export type ResolveNodesWithVariableReferences = ReturnType<typeof resolveNodesWithVariableReferencesCreate>;
